export default "__VITE_ASSET__BH5z8Wku__"